module.exports = __webpack_public_path__ + "officialStatic/img/trusteeship3.fda10b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/trusteeship3.png
// module id = HzBF
// module chunks = 0